import { render, staticRenderFns } from "./tableReimburs.vue?vue&type=template&id=08630942&scoped=true"
import script from "./tableReimburs.vue?vue&type=script&lang=js"
export * from "./tableReimburs.vue?vue&type=script&lang=js"
import style0 from "./tableReimburs.vue?vue&type=style&index=0&id=08630942&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08630942",
  null
  
)

export default component.exports